import React from 'react'
import { ReactComponent as FixingSvg } from '../assets/ilustraciones/fixing.svg'
import { ReactComponent as LogoSvg } from '../assets/ilustraciones/logo.svg'
import ErrorCard from './ErrorCard'

const ScreenNetworkError = () => {
    return (
        <div className='w-screen h-screen fixed z-[999] bg-[#D4E5FF] flex flex-col gap-6 font-libre-franklin font-bold text-blue_text text-center'>
            <div className='flex w-full items-center px-4 gap-8 py-2'>
                <LogoSvg />
                <div className='text-2xl w-[50%]'>
                    Te damos la bienvenida
                </div>
            </div>
            <div className='text-xs'>
                Accede a los mejores descuentos de tu zona
            </div>
            <ErrorCard title='¡No tienes conexión a la red!' text='Por favor, revisa tu Wi-Fi o datos.' />
        </div>
    )
}

export default ScreenNetworkError
